import { KollelStatus } from '@/models/in/KollelDtoIn';

/** Colour of the status dot in the kollels list, matching the palette project/support-request
 * statuses use (see helpers/projectStatus.ts). */
export const getKollelStatusColor = (status: KollelStatus): string => {
  if (status === KollelStatus.Approved) return 'var(--icon-status-6)';
  if (status === KollelStatus.Rejected) return 'var(--icon-status-4)';
  return 'var(--icon-status-1)';
};

export const getKollelStatusLabelKey = (status: KollelStatus): string => `kollels.status.${status}`;
